<template>
  <header class="header">
    <div class="header__middle">
      <Menu v-if="screenWidth < 992" />
      <Logo :result="siteDir" />
      <div class="header__blocks">
        <SearchEngineTop />
        <Entry v-if="screenWidth >= 768" />
        <SmallFavourite />
        <SmallBasket />
      </div>
    </div>
    <Menu v-if="screenWidth >= 992" />
  </header>
</template>

<script lang="ts" setup>
import Menu from '@components/Menu/Menu.vue';
import Logo from '@/components/Header/Logo.vue';
import SearchEngineTop from '@components/Search/SearchEngineTop/SearchEngineTop.vue';
import Entry from '@components/Cabinet/Entry/Entry.vue';
import SmallFavourite from '@components/Favourite/SmallFavourite.vue';
import SmallBasket from '@components/Basket/SmallBasket.vue';
import useScreenWidth from '@use/useScreenWidth';
import { useResultsStore } from '@/storePinia/stores/results';
import { computed } from 'vue';

const resultsStore = useResultsStore();
const screenWidth = useScreenWidth();

const siteDir = computed(() => resultsStore.siteLanguages.siteDir);
</script>

<style lang="scss" scoped>
.header {
  &__middle {
    display: grid;
    grid-template-columns: 24px 78px 1fr;
    align-items: center;
    height: 56px;
    grid-column-gap: 24px;
    @include point-md {
      height: 68px;
    }
    @include point-lg {
      grid-template-columns: 100px 1fr;
      height: 70px;
    }
  }
  &__blocks {
    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 16px;
    justify-content: flex-end;
    @include point-md {
      grid-column-gap: 20px;
    }
    @include point-lg {
      grid-column-gap: 24px;
    }
  }
}
</style>
